import { Network, NetworkId } from 'modules/network';

const Networks: Record<NetworkId, Network> = {
  pz: {
    id: 'pz',
    name: 'Partnerize',
  },
  direct: {
    id: 'direct',
    name: 'Direct',
  },
};

export { Networks };
